import { render } from "./B2BMemberItem.vue?vue&type=template&id=d87d4fb0&scoped=true"
import script from "./B2BMemberItem.vue?vue&type=script&lang=js"
export * from "./B2BMemberItem.vue?vue&type=script&lang=js"

import "./B2BMemberItem.vue?vue&type=style&index=0&id=d87d4fb0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d87d4fb0"]])

export default __exports__